import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegexPattern } from '@markant-platform/shared/util-helpers';
import { AddressValidators } from '../validation/address.validators';

type AddressControlType = 'street' | 'streetNumber' | 'zipCode' | 'city' | 'countryCode';

type AddressFormControlOptions = {
  required?: boolean;
};

export class AddressFormGroup extends FormGroup<Record<AddressControlType, FormControl>> {
  constructor(values?: Record<AddressControlType, string> | null, options?: AddressFormControlOptions) {
    super({
      street: new FormControl(values?.street ?? '', {
        nonNullable: !!options?.required,
        validators: [
          ...(options?.required ? [Validators.required] : []),
          AddressValidators.street,
          Validators.pattern(RegexPattern.XSS_PATTERN),
        ],
      }),
      streetNumber: new FormControl(values?.streetNumber ?? '', {
        nonNullable: !!options?.required,
        validators: [
          ...(options?.required ? [Validators.required] : []),
          AddressValidators.streetNumber,
          Validators.pattern(RegexPattern.XSS_PATTERN),
        ],
      }),
      zipCode: new FormControl(values?.zipCode ?? '', {
        nonNullable: !!options?.required,
        validators: [
          ...(options?.required ? [Validators.required] : []),
          AddressValidators.postalCode,
          Validators.pattern(RegexPattern.XSS_PATTERN),
        ],
      }),
      city: new FormControl(values?.city ?? '', {
        nonNullable: !!options?.required,
        validators: [...(options?.required ? [Validators.required] : []), Validators.pattern(RegexPattern.XSS_PATTERN)],
      }),
      countryCode: new FormControl(values?.countryCode ?? '', {
        nonNullable: !!options?.required,
        validators: [
          ...(options?.required ? [Validators.required] : []),
          Validators.pattern(RegexPattern.COUNTRY_ALPHA_2_CODE),
          Validators.pattern(RegexPattern.XSS_PATTERN),
        ],
      }),
    });
  }
}
